import React, { useEffect, useRef, useState } from 'react';

const ImageColorChanger = ({ src, onClick, brandColor = '--secondary', alt = '', style, cursor }) => {
  const canvasRef = useRef(null);
  const [dataUrl, setDataURL] = useState(null);

  const hexToRgb = hex => {
    hex = hex.replace(/^#/, '');
    let r, g, b;
    if (hex.length === 6) {
      r = parseInt(hex.substring(0, 2), 16);
      g = parseInt(hex.substring(2, 4), 16);
      b = parseInt(hex.substring(4, 6), 16);
    } else if (hex.length === 3) {
      r = parseInt(hex.substring(0, 1) + hex.substring(0, 1), 16);
      g = parseInt(hex.substring(1, 2) + hex.substring(1, 2), 16);
      b = parseInt(hex.substring(2, 3) + hex.substring(2, 3), 16);
    } else {
      return [0, 0, 0];
    }
    return [r, g, b];
  };

  const getCSSColor = () => {
    let value = brandColor;

    if (brandColor.startsWith('--')) {
      value = getComputedStyle(document.documentElement).getPropertyValue(brandColor);
    }

    if (value.startsWith('rgb')) {
      const [r, g, b] = value
        .replace(/[^\d,]/g, '')
        .split(',')
        .slice(0, 3)
        .map(Number);

      return [r, g, b];
    }

    return hexToRgb(value);
  };

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d', { willReadFrequently: true });
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.src = src;

    img.onload = () => {
      const color = getCSSColor(brandColor);
      try {
        canvas.width = img.width;
        canvas.height = img.height;

        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(img, 0, 0);
        ctx.globalCompositeOperation = 'source-in';
        ctx.fillStyle = `rgb(${color.join(',')})`;
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        ctx.globalCompositeOperation = 'source-over';

        setDataURL(canvas.toDataURL());
      } catch (e) {
        console.error('Failed to recolor image:', e);
      }
    };
  }, [src, brandColor]);

  return (
    <>
      <canvas ref={canvasRef} style={{ display: 'none' }} />
      {dataUrl && <img src={dataUrl || src} alt={alt} style={style} cursor={cursor} onClick={onClick} />}
    </>
  );
};

export default ImageColorChanger;
